import { IEntityMetaData, IPropretyAttribute } from "../../_models/IEntityMetaData";
import { GenericEntityBase, KeyType } from "../../_models/GenericEntityBase";
import { PropretyAttributes, Validation, NestedProperty, NavigationProperty } from "../../decorators/EntityDecorators";
import { PointOfService } from "./PointOfService.model";
import { RoomReservationInstance } from "./RoomReservationInstance.model";

export class Room extends GenericEntityBase<number> {
  @PropretyAttributes({
    attributes: [
      IPropretyAttribute.KeyProperty,
      IPropretyAttribute.Readonly
    ]
  })
  id: number = GenericEntityBase.GetDefaultId(KeyType.number);

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  iD_SP!: string;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  fK_POS!: number;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  status!: number;

  capacity?: number;

  @PropretyAttributes({ attributes: [IPropretyAttribute.Required] })
  @Validation({ maxLength: 50 })
  color!: string;

  @NestedProperty({ TargetType: PointOfService })
  pointOfService?: PointOfService;

  @NavigationProperty({ TargetType: RoomReservationInstance })
  roomReservationInstances?: RoomReservationInstance[];

  GetType(): IEntityMetaData {
    return Room.getMetaData();
  }
}
